// extracted by mini-css-extract-plugin
export default {"typechange":"login_typechange__PxzXs"};